import { RECEIVE_BUSINESS_PROFILE, IBusinessProfileState, BusinessProfileActionTypes } from "./types";

const initialState: IBusinessProfileState = {
    businessProfileData: undefined,
    isLoading: false,
};

export function businessProfileReducer(state = initialState, action: BusinessProfileActionTypes): IBusinessProfileState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case RECEIVE_BUSINESS_PROFILE:
            return {
                isLoading: false,
                businessProfileData: action.businessProfileData,
            };
        default:
            return state;
    }
}
